export enum WorkflowType {
  Standard = 'Standard',
  Allocation = 'Allocation',
  MeritLetter = 'MeritLetter',
  Achievement = 'Achievement'
}
